﻿﻿export interface ISurgicalHistory {
    name: string;
    when: string;
}
